import { useCallback, useState } from 'react';

export default (refOrElement) => {
  const [isOpen, setIsOpen] = useState(false);

  const onMouseEnter = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (isOpen && (refOrElement?.current ?? refOrElement)?.matches(':hover') === false) {
    setIsOpen(false);
  }

  return [isOpen, { onMouseEnter, onMouseLeave }];
};
